const elecDefault = 0.16;
const ngDefault = 0.3;
const propDefault = 1.28;
const oilDefault = 2.31;
const woodDefault = 460;

export const defaultUtilityCosts = {
    electricity: { dollarsPerUnit: elecDefault, dollarsPerMonth: 0, preTaxRebate: 0, tax: 13 },
    naturalGas: { dollarsPerUnit: ngDefault, dollarsPerMonth: 0, preTaxRebate: 0, tax: 13 },
    propane: { dollarsPerUnit: propDefault, dollarsPerMonth: 0, preTaxRebate: 0, tax: 13 },
    oil: { dollarsPerUnit: oilDefault, dollarsPerMonth: 0, preTaxRebate: 0, tax: 13 },
    wood: { dollarsPerUnit: woodDefault, dollarsPerMonth: 0, preTaxRebate: 0, tax: 13 },
};
